module.exports = __webpack_public_path__ + "img/012岳晋琛.46778cef.jpg";